var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mt-5",attrs:{"elevation":_vm.$root.ele}},[_c('v-data-table',{staticClass:"templates-table",attrs:{"headers":_vm.headers,"items":_vm.list,"footer-props":{
      'items-per-page-options': [10, 20, 50, -1]
    },"items-per-page":50},scopedSlots:_vm._u([{key:"item.action",fn:function(ref){
    var item = ref.item;
return [_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$router.push(("/users/" + (item.id)))}}},[_c('v-icon',[_vm._v(" mdi-pencil ")])],1)]}},{key:"item.type",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.type(item))+" ")]}},{key:"item.updated_by",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.updated(item))+" ")]}},{key:"item.name",fn:function(ref){
    var item = ref.item;
return [_c('div',{staticClass:"text-capitalize"},[_vm._v(" "+_vm._s(item.name)+" ")])]}}])}),_c('v-divider')],1)}
var staticRenderFns = []

export { render, staticRenderFns }